module.exports = __webpack_public_path__ + "static/img/1.abc38c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/1.png
// module id = D/7x
// module chunks = 1